import Request from "@services/request";
import { IUploadFormData } from "./types";

const Upload = async ({ file }: IUploadFormData) => {
    const formData = new FormData();

    formData.append("file", file);

    return await new Request().post<
        FormData,
        IReturnValue<{
            url: string;
        }>
    >("FILE_UPLOAD", formData);
};

// Main Object
const FileApis = {
    Upload,
};

export default FileApis;
